// @ts-check
import React, { Component } from "react"
import withContext from "./withContext"
import { Checkbox, Icon, Icon8 } from "ui"
import { getBlockByType } from "./blockTypes"

import styled from "react-emotion"
import Text from "ui/components/Text"

const ChildHeader = styled.span`
    cursor: pointer;
    ${props => (props.active ? "color: orange;" : null)} ${props =>
        props.hasChildren ? "font-weight: bold" : null};
`

/**
 * @augments {Component<{context: BlockContext}>}
 */
class Layers extends Component {
    state = {
        showContainers: true,
        showLabels: true
    }
    toggleContainersVisibility = () => {
        this.setState(({ showContainers }) => ({ showContainers: !showContainers }))
    }
    toggleLabelVisibility = () => {
        this.setState(({ showLabels }) => ({ showLabels: !showLabels }))
    }
    onSelectBlock = block => {
        this.props.context.actions.selectBlock(block.id)
        this.props.onSelectBlock()
        this.props.context.actions.stopHighlight()
    }
    onHoverBlock = block => {
        this.props.context.actions.highlightElement(block.id)
    }
    render() {
        return (
            <div>
                <div style={{ marginBottom: 10 }}>
                    <Text>Containers:
                        <span style={{ marginLeft: 5, marginRight: 10 }}>
                            <Checkbox
                                value={this.state.showContainers}
                                onChange={this.toggleContainersVisibility}
                            />
                        </span>
                        Labels:
                        <span style={{ marginLeft: 5 }}>
                            <Checkbox
                                value={this.state.showLabels}
                                onChange={this.toggleLabelVisibility}
                            />
                        </span>
                    </Text>
                </div>
                <div style={{ marginLeft: -20 }}>
                    <Text>
                        <Child
                            displayContainers={this.state.showContainers}
                            displayLabels={this.state.showLabels}
                            childBlock={this.props.context.tree[0]}
                            onSelectBlock={this.onSelectBlock}
                            onHoverBlock={this.onHoverBlock}
                            selectedBlock={this.props.context.editor.selected}
                        />
                    </Text>
                </div>
            </div>
        )
    }
}

/**
 * @augments {Component<{childBlock: BlockConfig, displayContainers: boolean, onSelectBlock: any, onHoverBlock: any, selectedBlock: EntityId}>}
 */
class Child extends Component {
    state = {
        showChildren: true,
    }
    toggleChildrenVisibility = () => {
        this.setState(({ showChildren }) => ({ showChildren: !showChildren }))
    }
    render() {
        const {
            childBlock,
            displayContainers,
            displayLabels,
            onSelectBlock,
            onHoverBlock,
            selectedBlock,
        } = this.props

        if (
            childBlock.type === "container" &&
            !displayContainers &&
            childBlock.id !== selectedBlock
        ) {
            return childBlock.childBlocks.map(childBlock => (
                <Child {...this.props} childBlock={childBlock} />
            ))
        }

        const icon = getBlockByType(childBlock.type).icon || "block"

        return (
            <div
                style={{
                    marginLeft: 21,
                    marginBottom: childBlock.childBlocks.length ? 6 : 0,
                    whiteSpace: "nowrap",
                }}
            >
                <div onMouseOver={() => onHoverBlock(childBlock)}>
                    <div style={{ marginBottom: 1 }}>
                        {childBlock.childBlocks.length ? (
                            <Icon
                                onClick={this.toggleChildrenVisibility}
                                icon={this.state.showChildren ? "caret-down" : "caret-right"}
                                style={{ cursor: "pointer", marginLeft: 2, marginRight: 10 }}
                            />
                        ) : (
                                <Icon8 icon={icon} style={{ width: 16 }} />
                            )}
                        <ChildHeader
                            active={childBlock.id === selectedBlock}
                            hasChildren={childBlock.childBlocks.length}
                            onClick={() => onSelectBlock(childBlock)}
                        >
                            {(this.props.displayLabels && childBlock.config.attributes.label) || childBlock.id}
                        </ChildHeader>
                    </div>
                </div>
                {this.state.showChildren && (
                    <div className="display-flex">
                        <div
                            style={{
                                width: 1,
                                background: "rgba(100,100,100,0.2)",
                                transform: "translateX(6.5px) translateY(-5px)",
                            }}
                        />
                        <div style={{ flex: 1 }}>
                            {childBlock.childBlocks.map(childBlock => (
                                <Child {...this.props} childBlock={childBlock} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default withContext(Layers)



// WEBPACK FOOTER //
// ./src/features/editor/Layers.js